import { Box, Title, Text, Stack } from "@mantine/core";
import { SubjectReviewList } from "./SubjectReviewList";
import { usePageTitle } from "../../shared/utils";

/** The reviewer's side: the same lists as the editor sees, but editable. */
export function Review() {
  usePageTitle("Проверка");

  return (
    <Box component="main" p="xl">
      <Stack gap="lg">
        <div>
          <Title order={2}>Проверка</Title>
          <Text c="dimmed" fz="sm">
            Нажмите на статус лекции, чтобы изменить его. Монтажёру начисляются
            ЧРА только после того, как лекция проверена.
          </Text>
        </div>
        <SubjectReviewList
          role="reviewer"
          editable
          emptyMessage="Вам не назначены предметы для проверки."
        />
      </Stack>
    </Box>
  );
}
